<template>
    <Navbar/>
    <Blog4Body/>
    <Footer/>
  </template>
  
  <script>
  import { defineComponent } from "vue";
  import Navbar from "@/components/NavbarBody.vue";
  import Blog4Body from "@/components/blog/Blog4Body.vue";
  import Footer from "@/components/FooterBody.vue"; 
  
  export default defineComponent({
    name: "Blog4View",
    components: {
      Navbar,
      Blog4Body,
      Footer
    },
  });
  </script>
  